import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import Typography from "@material-ui/core/Typography";
import withWidth from "@material-ui/core/withWidth";

const AcceptDeclineDialog = withWidth()(
  ({
    open,
    width,
    title,
    content,
    acceptText = "Accept",
    declineText = "Decline",
    onAccept,
    onDecline,
    onClose
  }) =>
    (open && (
      <Dialog
        open={open}
        onClose={onClose}
        scroll="paper"
        maxWidth="xl"
        fullScreen={width === "xs"}
        TransitionComponent={Slide}
        TransitionProps={{ direction: "up" }}
      >
        <DialogTitle disableTypography>
          <Typography variant="h6">{title}</Typography>
        </DialogTitle>
        <DialogContent>
          {(typeof content === "string" && (
            <DialogContentText>{content}</DialogContentText>
          )) ||
            content}
        </DialogContent>
        <DialogActions>
          <Button onClick={onAccept} autoFocus>
            {acceptText}
          </Button>
          <Button onClick={onDecline}>{declineText}</Button>
        </DialogActions>
      </Dialog>
    )) ||
    null
);

export default AcceptDeclineDialog;
